/* eslint-disable no-console */
const { useCallback } = require('react');
const { useGoogleReCaptcha } = require('react-google-recaptcha-v3');

const useHandleReCaptchaVerify = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha) {
      console.error('Execute recaptcha not yet available');
      return null;
    }

    const token = await executeRecaptcha('form_recaptcha');

    console.log('token', token);

    return token;
  }, [executeRecaptcha]);

  return { handleReCaptchaVerify };
};

export default useHandleReCaptchaVerify;
